module.exports = __webpack_public_path__ + "img/idcard.6b47268f.png";